import { Loader } from "lucide-react";

type ProgressToastProps = {
	message: string;
	progress: number;
	weighted?: boolean;
};

function weightedProgress(actual: number): number {
	if (actual <= 0) return 0;
	if (actual >= 100) return 100;
	return Math.pow(actual / 100, 0.4) * 100;
}

export function ProgressToast({
	message,
	progress,
	weighted = true,
}: ProgressToastProps) {
	const displayed = weighted ? weightedProgress(progress) : progress;
	const isComplete = progress >= 100;

	return (
		<div className="rounded-lg border border-border bg-background text-foreground shadow-lg overflow-hidden">
			<div className="flex items-center gap-3 text-sm px-4 py-3">
				<Loader className="h-4 w-4 animate-spin text-muted-foreground shrink-0" />
				<span>{message}</span>
			</div>
			<div className="h-1 bg-primary/20">
				<div
					className="h-full bg-primary transition-all duration-500 ease-out relative overflow-hidden"
					style={{ width: `${displayed}%` }}
				>
					{!isComplete && (
						<div className="absolute inset-0 animate-progress-shimmer" />
					)}
				</div>
			</div>
		</div>
	);
}

/** Default options for progress toast.custom() calls */
export const PROGRESS_TOAST_OPTIONS = {
	duration: Infinity,
	position: "top-center" as const,
};
